import React from 'react';
import { Loader, CheckCircle, AlertCircle } from 'lucide-react';

interface ReportStatusProps {
  status: 'pending' | 'completed' | 'failed';
}

export default function ReportStatus({ status }: ReportStatusProps) {
  const statusConfig = {
    pending: {
      icon: <Loader className="w-4 h-4 animate-spin" />,
      text: 'Generating report...',
      className: 'text-yellow-600 bg-yellow-50'
    },
    completed: {
      icon: <CheckCircle className="w-4 h-4" />,
      text: 'Report ready',
      className: 'text-green-600 bg-green-50'
    },
    failed: {
      icon: <AlertCircle className="w-4 h-4" />,
      text: 'Generation failed',
      className: 'text-red-600 bg-red-50'
    }
  };

  const config = statusConfig[status];

  return (
    <div className={`flex items-center space-x-2 px-3 py-1 rounded-full ${config.className}`}>
      {config.icon}
      <span className="text-sm font-medium">{config.text}</span>
    </div>
  );
}